import { Form, Formik } from "formik";
import { useRef, useState } from "react";
import Input from "../../components/common/inputs/Input";
import Button from "../../components/common/button/Button";
import { useLocation, useNavigate } from "react-router";
import { motion } from "framer-motion";
import PermissionSelect from "../../components/common/inputs/PermissionSelect";
import { postApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { FaUsers } from "react-icons/fa";

export default function Permission() {
  const [permissions, setPermissions] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();
  const permissionRef = useRef();

  const formHandler = async (values, { resetForm }) => {
    const path = "admin/permissions";

    const newPermissions = permissions.map((item) => {
      return {
        resource: item,
      };
    });
    const body = {
      ...values,
      permissions: newPermissions,
    };
    if (permissions?.length) {
      try {
        await postApi({ path, body });
        resetForm();
        successMessage("دسترسی با موفقیت ثبت شد.");
        permissionRef.current.afterSubmit();
        setPermissions([]);
        navigate('/permission-list')
      } catch (error) {
        errorMessage(error?.response?.data?.errors[0].message);
        console.log(error);
      }
    } else {
      warningMessage("لطفا حد اقل یک دسترسی را انتخاب کنید.");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.5,
        // ease: [0, 0.71, 0.2, 1.01]
      }}
      className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6"
    >
      <h6 className="mb-6 mt-2 text-gray-800 dark:text-white flex gap-x-2 items-center">
        <FaUsers size={26} />
        افزودن دسترسی
      </h6>
      <Formik
        enableReinitialize
        initialValues={{
          name: location?.state?.name || "",
        }}
        onSubmit={formHandler}
      >
        {() => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input
                  name={"name"}
                  placeholder={"نام"}
                  label="نام"
                  type="text"
                />

                <PermissionSelect
                  ref={permissionRef}
                  label="انتخاب دسترسی"
                  onChange={setPermissions}
                  oldPermissions={location?.state?.permissions}
                />
              </div>

              <div className="flex flex-col gap-y-2">
                <div className="flex items-center gap-2 mt-6">
                  <Button
                    text={location?.state ? "ویرایش" : "افزون"}
                    color={"success"}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </motion.div>
  );
}
